"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reselect_1 = require("reselect");
const safe_access_1 = __importDefault(require("safe-access"));
const remoting_1 = __importDefault(require("./remoting"));
/** @module selectors/pairing */
const getPairing = state => safe_access_1.default(state, 'app.remoting.pairing') || {};
/**
 * @class PairingStateSelectorResult
 * @type {Object}
 * @property {any} createDisplayError
 * @property {string} deviceClient
 * @property {string} deviceJWT
 * @property {string} displayCipher
 * @property {boolean} isCreatingDevice is this device in the process of creating a new room?
 * @property {boolean} isUnlinking is this device in the process of unlinking?
 * @property {any} linkingError
 * @property {any} loginError
 * @property {string} pairedUuid the uuid of the other device
 * @property {string} presenterLinkingUrl the url for wireless presenter to authenticate and present
 * @property {string} presenters an array of authenticated presenters
 * @property {string} remoteLinkingCode QR Code
 * @property {string} uuid the uuid of the current device (display device or remote device)
 */
/**
 * Selects the current pairing status
//  * @return { PairingStateSelectorResult } The result
 */
const getPresenterLinkingUrl = state => remoting_1.default.getWirelessPresentationUrl(state);
const pairingState = reselect_1.createSelector([getPairing, getPresenterLinkingUrl], (pairing, presenterLinkingUrl) => {
    return {
        createDisplayError: pairing.createDisplayError,
        deviceClient: pairing.deviceClient,
        deviceJWT: pairing.deviceJWT,
        displayCipher: pairing.displayCipher,
        isCreatingDevice: pairing.isCreatingDevice,
        isUnlinking: pairing.isUnlinking,
        linkingError: pairing.linkingError,
        loginDeviceError: pairing.loginError,
        pairedUuid: pairing.pairedUuid,
        presenterLinkingUrl,
        presenters: pairing.presenters,
        remoteLinkingCode: pairing.remoteLinkingCode,
        uuid: pairing.uuid
    };
});
exports.default = { pairingState };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/selectors/pairing.js
// module id = 610
// module chunks = 0